import {Common} from '../mutation-types';

export default {
    namespaced: true,
    state: {
        showSpinner : false
    },
    getters: {
        showSpinner: function(state) {
            return state.showSpinner;
        }
    },
    mutations: {
        // 사용자 계정 저장
        [Common.SPINNER_STATE] (state, payload) {
            state.showSpinner = payload;
        }
    },
    actions: {

    }
}


// WEBPACK FOOTER //
// ./src/store/modules/common.js